// extracted by mini-css-extract-plugin
module.exports = {"root":"ExtraOptions_root__2cjJm","head":"ExtraOptions_head__CraUH"};